export default {
  white: '#ffffff',
  bgGray: '#F6F6F6',
  grayLight: '#DFDFDF',
  bgScreen: '#FAFAFA',
  textExGrayLight: '#EFEFEF',
  textSecondary: '#9CA1AE',
  textPrimary: '#2A2C31',
  shadow: 'rgba(0, 0, 0, 0.1)',
  shadowHover: 'rgba(0, 0, 0, 0.25)',
  bgTertiaryLight: '#F5E894',
  bgTertiary: '#EFCE00',
  bgTertiaryHover: '#BEA610',
  bgTertiaryShadow: 'rgba(239, 206, 0, 0.3)',
  bgSecondary: '#037468',
  bgSecondaryHover: '#05443D',
  bgSecondaryLight: '#83B9B3',
  bgSuccess: '#14A292',
  bgFilterSelected: 'rgba(50, 180, 160, 1)',
  bgFourthLight: '#7573d7',
  textHyperlink: '#25BBAB',
  bgPrimary: '#002360',
  bgPrimaryHover: '#001A47',
  bgPrimaryLight: '#62799F',
  bgDanger: '#F25E5E',
  bgDangerShadow: 'rgba(242, 94, 94, 0.2)',
  menuHover: 'rgba(98, 121, 159, 0.16)',
  readOnlyBorder: 'rgba(156, 161, 174, 0.1)',
  bgOverlay: 'rgba(0, 0, 0, 0.41)',
  black: '#000000',
  bgDarkOrange: '#F28963',
  green: '#20bf04',
  gamerGray:'#e3e3e3',
  darkblue: '#00008f',
  normalGray: '#D9D9D9',
  successGreen: '#4BB543',
  darkGray: '#9A9A9A',
  yellow: '#F9C915',
  alertaAmarilloFondo: '#fffbea',
  alertaAmarilloBorde: '#f6c343',
  alertaNaranjaFondo: '#fff4e6', 
  alertaNaranjaBorde: '#ff9900', 
  alertaRojoFondo: '#ffecec', 
  alertaRojoBorde: '#ff0000', 
  alertaVerdeFondo: '#e6ffe6', 
  alertaVerdeBorde: '#00cc00',

}
